import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';
import merge from 'lodash-es/merge';

import cloneDeep from 'lodash-es/cloneDeep';

import lookAndFeel from '../lookAndFeel';

import updateStyleByRef from '../css/updateStyleByRef';

import 'choices.js/public/assets/styles/choices.min.css';
import frameProps from '../css/frameProps';

import omit from 'lodash-es/omit';
import getDefaultStyle from '../css/defaultStyle';
import updateClass from '../css/updateClass';

const filterFixedTopClass = {
  bottom: '100%',
  position: 'absolute',
  left: '0px',
};

const filterFixedBottomClass = {
  top: '100%',
  position: 'absolute',
  left: '0px',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
};

const defaultClass = [
  {
    // widget body
    selector: '.choices[data-type*=select-multiple] .choices__inner',
    properties: {
      backgroundColor: '${schemeSysBackground}',
      borderColor: 'rgba(255,255,255,0.5)',
      overflow: 'auto',
      //padding: '24px 2px 2px 2px',
      width:'100%!important',
      height:'auto!important'
    },
  },
  {
    // filter
    selector: ".choices input[type='text'].choices__input",
    properties: {
      height: '24px',
      width: '100%!important',
      fontSize: '${schemeFontSize}',
      lineHeight: '${schemeFontSize}',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      color: '${schemeForeground}',
      borderColor: 'inherit',
    },
  },
  {
    // selected item
    selector: '.choices__list--multiple .choices__item',
    properties: {
      fontSize: '${schemeFontSize}',
      backgroundColor: '${schemeBackground}',
      border: '1px solid ${schemeShade}',
      color: '${schemeForeground}',
      boxShadow: '0px 0px 6px rgba(0,0,0,0.5), 0px -4px 14px 1px ${schemeShade} inset',
      textShadow: '0px 0px 4px #000000',
    },
  },
  {
    // selected item close button
    selector: '.choices[data-type*=select-multiple] .choices__button',
    properties: {
      borderLeft: '1px solid rgba(255,255,255,0.5)',
      color: '${schemeForeground}',
      textShadow: '0px 0px 4px #000000',
    },
  },

  {
    // dropdown
    selector: '.choices__list--dropdown',
    properties: {
      backgroundColor: '${schemeSysBackground}',
      color: '${schemeForeground}',
      borderColor: 'rgba(255,255,255,0.5)',
    },
  },
  {
    //item
    selector: '.choices__list--dropdown .choices__item',
    properties: {
      fontSize: '${schemeFontSize}',
      paddingRight: '10px',
    },
  },
  {
    // hovered item
    selector: '.choices__list--dropdown .choices__item--selectable.is-highlighted',
    properties: {
      backgroundColor: '${schemeBackground}',
      color: '${schemeForeground}',
    },
  },
];

const defaultClassFlat = [
  {
    // widget body
    selector: '.choices[data-type*=select-multiple] .choices__inner',
    properties: {      
    },
  },
  {
    // filter
    selector: ".choices input[type='text'].choices__input",
    properties: {      
    },
  },
  {
    // selected item
    selector: '.choices__list--multiple .choices__item',
    properties: {      
      border: '1px solid ${schemeBackground}',
      borderRadius:'8px',
      boxShadow: '0px 0px 6px rgba(0,0,0,0.5)',
      textShadow: 'none',
    },
  },
  {
    // selected item close button
    selector: '.choices[data-type*=select-multiple] .choices__button',
    properties: {      
      textShadow: 'none',
    },
  },

  {
    // dropdown
    selector: '.choices__list--dropdown',
    properties: {      
    },
  },
  {
    //item
    selector: '.choices__list--dropdown .choices__item',
    properties: {      
    },
  },
  {
    // hovered item
    selector: '.choices__list--dropdown .choices__item--selectable.is-highlighted',
    properties: {      
    },
  },
];


const defaultScheme = lookAndFeel();
updateClass(
  'io-choices-default-style',
  updateStyleByRef(cloneDeep(defaultClass), defaultScheme),
  '.io-choices-default'
);

updateClass(
  'io-choices-default-style-flat',
  updateStyleByRef(cloneDeep(defaultClassFlat), defaultScheme),
  '.io-choices-default-flat'
);

export function updateChoicesClasses(control, options) {  

  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  let normal = get(options, 'style.normal');
  let filterPosition = get(options, 'filter.position');
  const dropdown = {};
  if (filterPosition === 'fixedTop') {
    filterPosition = filterFixedTopClass;
  } else if (filterPosition === 'fixedBottom') {
    filterPosition = filterFixedBottomClass;
    dropdown.marginTop = '23px';
  } else {
    filterPosition = {};
  }

  let filter = get(options, 'filter.style.normal');
  let item = get(options, 'item.style') || {};
  let scheme = lookAndFeel(options.lookAndFeel, normal.height);
  let CSS = updateStyleByRef(
    merge(cloneDeep(defaultClass),design=='flat'?defaultClassFlat:{}, [
      {
        // widget
        // properties: omit(normal, frameProps),
        properties: normal,
      },
      {
        // filter
        properties: { ...filterPosition, ...filter },
      },
      {
        // selected item
        properties: item.selected,
      },
      {
        // selected item close button
      },

      {
        // dropdown
        properties: {
          ...dropdown,
          backgroundColor: item.normal && item.normal.backgroundColor,
          color: item.normal && item.normal.color,
        },
      },
      {
        //item
        properties: item.normal,
      },
      {
        // hovered item
        properties: item.hover,
      },
    ]),
    scheme
  );

  if (isEqual(control.CSS, CSS)) {
    return;
  }

  control.CSS = CSS;
  control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);
}

export function getDefaultControlStyle() {
  if (!getDefaultControlStyle.style) {    
    getDefaultControlStyle.style = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        boxSizing: 'border-box',
        top: '8px',
        left: '8px',
        width: '312px',
        height: '68px',
        display: 'inline-block',
        margin: '0px',
      }),
    };
  }

  return getDefaultControlStyle.style;
}

export function getDefaultControl(control) {  
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  var cmb = document.createElement('div');
  cmb.classList.add('io-choices-default');
  if(design=='flat'){
    cmb.classList.add('io-choices-default-flat');
  }

  cmb.classList.add('controls');
  cmb.innerHTML = '<select class="body" multiple></select>';
  return cmb;
}
